import { render, staticRenderFns } from "./SidebarMenuIcon.vue?vue&type=template&id=6f9754a0&"
import script from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f9754a0')) {
      api.createRecord('6f9754a0', component.options)
    } else {
      api.reload('6f9754a0', component.options)
    }
    module.hot.accept("./SidebarMenuIcon.vue?vue&type=template&id=6f9754a0&", function () {
      api.rerender('6f9754a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SidebarMenu/SidebarMenuIcon.vue"
export default component.exports